import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { useEditorSessionObserver } from '../EditorSession';
import { useComponentObserver } from '../visualization/ComponentObserver';
import { ActiveMeetingInfo } from './ActiveMeetingInfo';
import { Meeting } from './Meeting';
import { Phase } from './Phase';

export const useActiveMeeting = () => {
    const objects = useResolve(ObjectManager);
    const ami = useEditorSessionObserver(ActiveMeetingInfo);
    const meeting = objects.getMaybe(ami.meetingId, Meeting);
    useComponentObserver(meeting);
    return meeting;
};

export const useActivePhase = () => {
    const objects = useResolve(ObjectManager);
    const ami = useEditorSessionObserver(ActiveMeetingInfo);
    const phase = objects.getMaybe(ami.phaseId, Phase);
    useComponentObserver(phase);
    return phase;
};

export const useActiveMeetingAndPhase = () => {

    const objects = useResolve(ObjectManager);
    const ami = useEditorSessionObserver(ActiveMeetingInfo);

    const meeting = objects.getMaybe(ami.meetingId, Meeting);
    const phase = objects.getMaybe(ami.phaseId, Phase);

    useComponentObserver(meeting);
    useComponentObserver(phase);

    return [meeting, phase] as const;
};
